import { Form } from 'antd';
import {} from 'antd';
import {
  AButton,
  AModal,
  ARate,
  ASelect,
  ATextArea,
  ToSignature,
  ATitle,
  OptionFooter,
} from '../../../../components';
import { IFormLog, ISchedule } from '../../../../shared/interfaces';
import { useCallback, useEffect, useState } from 'react';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import { CloseCircleOutlined } from '@ant-design/icons';
import { formatDate } from '../../../../shared/utils/format-date';

interface ICreateEvolutionProps {
  open: boolean;
  close: () => void;
  client_form_id: string | undefined;
  clientFormLog: IFormLog | null;
  setClientFormLogs: React.Dispatch<React.SetStateAction<IFormLog[]>>;
  schedules: ISchedule[];
}
const EvolutionCreate: React.FC<ICreateEvolutionProps> = ({
  open,
  close,
  client_form_id,
  clientFormLog,
  setClientFormLogs,
  schedules,
}) => {
  const { addToast } = useToast();
  const [description, setDescription] = useState<string>();
  const [rank, setRank] = useState<number>(0);
  const [schedule_id, setSchedule_id] = useState<string>();
  const [formProfessionalId, setFormProfessionalId] = useState<string>();
  const [modalSign, setModalSign] = useState<boolean>(false);
  const [signaturePassword, setSignaturePassword] = useState<string | null>(
    null,
  );

  const handleSubmit = useCallback(async () => {
    if (description && client_form_id) {
      const data: IFormLog = {
        client_form_id,
        observation: description,
        rank,
        schedule_id,
      };
      await api
        .post(`/clients-forms-logs/`, data)
        .then(async (response) => {
          if (
            signaturePassword &&
            response.data?.id &&
            response.data?.professional_id
          ) {
            await api.post('/signature-validation/sign', {
              document_type: 'FORM_EVOLUTION',
              record_id: response.data.id,
              professional_id: response.data.professional_id,
              password: signaturePassword,
            });
          }

          setClientFormLogs((state: IFormLog[]) => [...state, response.data]);
          addToast({
            type: 'success',
            title: 'Cadastrado',
            description: signaturePassword
              ? 'Evolução cadastrada e assinada com sucesso.'
              : 'Cadastrado com sucesso.',
          });
          setSignaturePassword(null);
          close();
        })
        .catch((err) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: err.response.data.message,
          });
        });
    } else {
      addToast({
        type: 'warning',
        title: 'Aviso',
        description: 'Preencha a descrição da evolução',
      });
    }
  }, [
    description,
    rank,
    client_form_id,
    schedule_id,
    signaturePassword,
    addToast,
    close,
    setClientFormLogs,
  ]);

  useEffect(() => {
    if (clientFormLog) {
      setDescription(clientFormLog.observation);
      setRank(clientFormLog.rank);
      setSchedule_id(clientFormLog.schedule_id);
    }
    if (open && client_form_id && !clientFormLog) {
      api.get(`/clients-forms/${client_form_id}`).then((response) => {
        setFormProfessionalId(response.data?.form?.professional_id);
      });
    }
  }, [open]);

  return (
    <AModal
      open={open}
      close={close}
      title={clientFormLog ? 'Detalhes da Evolução' : 'Cadastrar Evolução'}
      footer={
        <OptionFooter
          onClickCancel={() => close()}
          cancelText="Fechar"
          onClickOk={handleSubmit}
          showOk={!clientFormLog}
          iconCancel={<CloseCircleOutlined />}
        />
      }
    >
      <Form layout="vertical">
        {clientFormLog && (
          <Form.Item label="Professional">
            <ATitle level={4} color="#1677ff">
              {clientFormLog?.professional_name}
            </ATitle>
          </Form.Item>
        )}
        <Form.Item label="Descrição">
          <ATextArea
            rows={5}
            placeholder="descreva suas observações"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ resize: 'none' }}
            disabled={!!clientFormLog}
          />
        </Form.Item>
        <Form.Item label="Avaliação">
          <ARate
            value={rank}
            onChange={(e) => setRank(e)}
            tooltips={['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']}
            count={10}
            disabled={!!clientFormLog}
          />
        </Form.Item>
        <Form.Item label="Data do Atendimento">
          <ASelect
            showSearch
            placeholder="Selecione a data"
            optionFilterProp="children"
            onChange={(e) => setSchedule_id(e)}
            filterOption={(input, option: any) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            value={schedule_id}
            allowClear
            options={schedules.map((schedule) => ({
              label: `${schedule.title} => ${formatDate(
                schedule.start,
                'DD/MM/YYYY',
              )} ${formatDate(schedule.start, 'HH:mm')} - ${formatDate(
                schedule.end,
                'HH:mm',
              )}`,
              value: schedule.id,
            }))}
            disabled={!!clientFormLog}
          />
        </Form.Item>
        {!clientFormLog && formProfessionalId && (
          <Form.Item label="Assinatura Digital">
            <AButton type="dashed" onClick={() => setModalSign(true)}>
              {signaturePassword
                ? 'Assinatura validada para salvar'
                : 'Autenticar assinatura do profissional'}
            </AButton>
          </Form.Item>
        )}
      </Form>
      <ToSignature
        open={modalSign}
        close={() => setModalSign(false)}
        professional_id={formProfessionalId}
        onAuthenticated={async (_authData, password) => {
          setSignaturePassword(password);
          addToast({
            type: 'success',
            title: 'Assinatura validada',
            description: 'A evolução será assinada ao salvar.',
          });
        }}
      />
    </AModal>
  );
};

export default EvolutionCreate;
